import {Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, ChangeDetectorRef} from '@angular/core';
import { RoadTaxService } from './road-tax.service';
import { ToastMessage } from '../../toast-message/toast-message.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LogService } from '../../log-service.service';
import { ConstantsService } from '../../constants.service';
import { Subject } from 'rxjs';
import { ImageZoomService } from '../../services/image-zoom.service';
import { FormControl } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';

const _ = require('lodash');
const moment = require('moment');

@Component({
  selector: 'app-road-tax',
  template: require('./road-tax.component.html'),
  providers: [ToastMessage, RoadTaxService, LogService, ConstantsService]
})
export class RoadTaxComponent implements OnInit, OnChanges {

  constructor(
    private _roadTaxService: RoadTaxService,
    private _toastMessage: ToastMessage,
    private spinnerService: Ng4LoadingSpinnerService,
    private _logService: LogService,
    private constantService: ConstantsService,
    private imageZoomService: ImageZoomService,
    private _hotkeysService: HotkeysService) { }

  @Input() data: any;
  @Input() allowEditing: any;
  @Input() showFront = false;
  @Input() showBack = false;
  @Input() userIdentity: any = {};
  @Input() isRoadTaxRejected: any;
  @Input() roadTaxRegData: any;
  @Input() showRoadTaxVerify: any;
  @Output() roadTaxStatus: EventEmitter<any> = new EventEmitter();
  @Output() fetchData: EventEmitter<any> = new EventEmitter();
  @Output() addRoadTaxToRejectList: EventEmitter<any> = new EventEmitter();
  @Output() roadTaxDoc: EventEmitter<any> = new EventEmitter();
  @Output() roadTaxVehicleNumber: EventEmitter<any> = new EventEmitter();

  public screenBreakpoint = false;
  public updateImageEnabled = false;
  public roadTaxData: any;
  public imgFront: any;
  public riderId: any;
  public fleetId: any;
  public fleetNumber: any;
  public fleetOnboarding = false;
  public hideImageUploadForFleetOnboarding = false;
  public imgFrontData: any;
  public roadTaxInfo: any;
  public vehicleNumber: string = '';
  public oldVehicleNumber: string = '';
  public vehicleModel: any;
  public oldVehicleModel: any;
  public vehicles: any;
  public vehicleList = [];
  public vehicleListArray = [];
  public displayNames = {};
  public manufacturers = {};
  public vehicleTypes = {};
  public vehicleMode: any;
  public registrationDateUpdated = false;
  public oldRegistrationDate: any;
  public showButtonIcon = false;
  public expiresOnFormControl = new FormControl(null);
  public showApproveButton = false;
  public roadTaxApprovalMessage: any;
  public isRoadTaxApproved = false;
  public isRoadTaxAutoApproved = false;
  public roadTaxApprovalStatus = 'Approved';
  public APPROVAL_MESSAGE = this.constantService.approvalMessage;
  public asyncRefreshTrigger: Subject<void> = new Subject<void>();
  public thirdPartyStatus: any;
  public thirdPartyMessage: any;
  public verificationPlatform: any;
  public verifiedOn: any;
  public isRoadTaxAccepted: any;
  public isRoadTaxImageOptional = false;

  private rotateFrontImageDegrees = 0;

  onResize(event) {
    this.screenBreakpoint = (event.target.innerWidth <= 1040) ? true : false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.roadTaxRegData && changes.roadTaxRegData.currentValue) {
      this.thirdPartyStatus = changes.roadTaxRegData.currentValue.status;
      this.thirdPartyMessage = changes.roadTaxRegData.currentValue.message;
      this.verificationPlatform = changes.roadTaxRegData.currentValue.verifiedBy;
      this.verifiedOn = changes.roadTaxRegData.currentValue.verifiedOn;
      this.isRoadTaxAccepted = changes.roadTaxRegData.currentValue.isRoadTaxAccepted;
      this.showRoadTaxVerify = !this.isRoadTaxAccepted;
      if (this.isRoadTaxApproved) {
        this.showRoadTaxVerify = false;
      }
    }
    if (changes && changes.data && changes.data.currentValue) {
      this.fleetNumber = changes.data.currentValue.fleetNumber;
      this.fleetOnboarding = changes.data.currentValue.fleetOnboarding;
      this.fleetId = changes.data.currentValue.fleet;
      this.hideImageUploadForFleetOnboarding = true;
    }

    if (changes.data) {
      this.roadTaxData = changes.data.currentValue;
      
      // Update vehicle mode when data changes
      if (changes.data.currentValue && changes.data.currentValue.modeId && changes.data.currentValue.modeId.mode) {
        this.vehicleMode = changes.data.currentValue.modeId.mode;
        this.getVehiclesList();
      }
      
      // Initialize roadTax data structure
      if (this.roadTaxData && this.roadTaxData.roadTax) {
        this.roadTaxInfo = this.roadTaxData.roadTax;
        // Get isImageOptional from data.roadTax.info.isImageOptional
        this.isRoadTaxImageOptional = !!(this.roadTaxInfo.info && this.roadTaxInfo.info.isImageOptional);
        
        // Get image from data.roadTax.images.front.path
        if (this.roadTaxInfo.images && this.roadTaxInfo.images.front && this.roadTaxInfo.images.front.path) {
          this.imgFront = this.roadTaxInfo.images.front.path;
        } else if (this.roadTaxInfo.frontLink) {
          // Fallback to frontLink if images structure doesn't exist
          this.imgFront = this.roadTaxInfo.frontLink;
        } else {
          this.imgFront = null;
        }
        
        // Get vehicle number from data.roadTax.number
        this.vehicleNumber = (this.roadTaxInfo.number || this.roadTaxInfo.vehicleNumber || '').toString();
        this.oldVehicleNumber = this.vehicleNumber;
        // Emit vehicle number for verification
        if (this.vehicleNumber) {
          this.roadTaxVehicleNumber.emit(this.vehicleNumber);
        }
        
        // Get vehicle model from data.roadTax.info.vehicleModel
        this.vehicleModel = (this.roadTaxInfo.info && this.roadTaxInfo.info.vehicleModel) 
          ? this.roadTaxInfo.info.vehicleModel 
          : (this.roadTaxInfo.vehicleModel || null);
        this.oldVehicleModel = this.vehicleModel;
        
        // Initialize registration date from data.roadTax.info.registrationDate
        const registrationDateValue = (this.roadTaxInfo.info && this.roadTaxInfo.info.registrationDate)
          ? this.roadTaxInfo.info.registrationDate
          : (this.roadTaxInfo.registrationDate || '');
        this.oldRegistrationDate = registrationDateValue;
        if (registrationDateValue) {
          const registrationDate = new Date(registrationDateValue);
          if (!isNaN(registrationDate.getTime())) {
            this.expiresOnFormControl.setValue(registrationDate);
          } else {
            this.expiresOnFormControl.setValue(null);
          }
        } else {
          this.expiresOnFormControl.setValue(null);
        }
        
        if (this.imgFront && this.fleetOnboarding) {
          this.hideImageUploadForFleetOnboarding = false;
        }
        
        // Set showApproveButton based on isImageOptional or required fields
        this.updateShowApproveButton();
      } else {
        // Initialize empty structure
        this.roadTaxInfo = {
          images: {
            front: {
              path: ''
            }
          },
          vehicleNumber: ''
        };
        this.imgFront = null;
        this.vehicleNumber = '';
        this.oldVehicleNumber = '';
        this.vehicleModel = null;
        this.oldVehicleModel = null;
        this.expiresOnFormControl.setValue(null);
        this.oldRegistrationDate = '';
      }

      this.riderId = this.roadTaxData._id;

      if (this.roadTaxInfo && this.roadTaxInfo.status == 'processing') {
        this.updateShowApproveButton();
      }

      if (this.roadTaxInfo && this.roadTaxInfo.status == 'approved') {
        this.formApprovalMessage();
      }
    }
  }

  ngOnInit() {
    this.screenBreakpoint = (window.innerWidth <= 1040) ? true : false;
    if (this.data && this.data.modeId && this.data.modeId.mode) {
      this.vehicleMode = this.data.modeId.mode;
    }
    this.getVehiclesList();
  }

  getVehiclesList() {
    if (this.data && this.data.modeId && this.data.modeId._id) {
      let response;
      this._roadTaxService.getVehiclesList(this.data.modeId._id).subscribe(resp => {
        response = resp;
        this.vehicleList = [];
        this.vehicles = response.data.vehicles;
        if (this.vehicles) {
          if (Array.isArray(this.vehicles)) {
            // If vehicles is an array, use it directly
            this.vehicleList = this.vehicles.filter(item => item);
          } else {
            // If vehicles is an object, iterate over keys
            for (const key in this.vehicles) {
              if (this.vehicles[key]) {
                this.vehicleList.push(this.vehicles[key]);
              }
            }
          }
        }
        this.vehicleListArray = this.vehicleList.reduce((acc, item) => {
          acc[item._id] = item.model;
          return acc;
        }, {});
        this.displayNames = this.vehicleList.reduce((acc, item) => {
          acc[item._id] = item.displayName || "";
          return acc;
        }, {});
        this.manufacturers = this.vehicleList.reduce((acc, item) => {
          acc[item._id] = item.manufacturer || "";
          return acc;
        }, {});
        this.vehicleTypes = this.vehicleList.reduce((acc, item) => {
          acc[item._id] = item.bodyType || "hatchback";
          return acc;
        }, {});
      },
      err => {
        this._toastMessage.openSnackBarError('Could not retrieve list of vehicles');
        console.log('RoadTax getVehiclesList error:', err);
      });
    }
  }

  getVehicleName(vehicleModelId) {
    if (!vehicleModelId) return '';
    for (let i = 0; i < this.vehicleList.length; i++) {
      if (this.vehicleList[i]['_id'] === vehicleModelId) {
        return this.vehicleList[i]['model'];
      }
    }
    return '';
  }

  onVehicleModelChange() {
    // This is called when the dropdown value changes
    // The update button will show if vehicleModel !== oldVehicleModel
  }

  updateVehicleModel() {
    if (this.vehicleModel === this.oldVehicleModel) {
      this._toastMessage.openSnackBarError('No update required, Vehicle model is the same');
      return;
    }
    this.spinnerService.show();
    let userId = this.riderId;
    if (this.fleetId) {
      userId = this.fleetId;
    }
    this._roadTaxService.updateVehicleModel(userId, this.vehicleModel, this.fleetNumber).subscribe(
      response => {
        this.spinnerService.hide();
        this.oldVehicleModel = this.vehicleModel;
        this._toastMessage.openSnackBarSuccess('Vehicle model updated successfully');
        this.updateShowApproveButton();
        this.fetchData.emit();
      },
      error => {
        this.spinnerService.hide();
        const errorMessage = error && error.error && error.error.message || 'Could not update vehicle model';
        this._toastMessage.openSnackBarError(errorMessage);
      }
    );
  }

  dateChanged(evt: any) {
    this.registrationDateUpdated = true;
    this.showButtonIcon = true;
    if (evt.value) {
      // Store the date value
      this.roadTaxInfo.registrationDate = evt.value;
    }
    this.updateShowApproveButton();
  }

  updateRegistrationDate() {
    let response, oldRegistrationDate;
    this.spinnerService.show();
    let userId = this.riderId;
    if (this.fleetId) {
      userId = this.fleetId;
    }
    const registrationDate = this.expiresOnFormControl.value;
    if (!registrationDate) {
      this.spinnerService.hide();
      this._toastMessage.openSnackBarError('Please select a registration date');
      return;
    }
    const formattedDate = moment(registrationDate).format('YYYY-MM-DD');
    this._roadTaxService.updateRegistrationDate(userId, formattedDate, this.fleetNumber).subscribe(
      res => {
        response = res;
        this.spinnerService.hide();
        oldRegistrationDate = this.oldRegistrationDate;
        if (this.roadTaxInfo) {
          this.roadTaxInfo.registrationDate = formattedDate;
        }
        this.oldRegistrationDate = formattedDate;
        this.registrationDateUpdated = false;
        this.showButtonIcon = false;
        this._toastMessage.openSnackBarSuccess('Registration date updated successfully');
        this.updateShowApproveButton();
        this.fetchData.emit();
      },
      error => {
        this.spinnerService.hide();
        const errorMessage = error && error.error && error.error.message || 'Could not update registration date';
        this._toastMessage.openSnackBarError(errorMessage);
      }
    );
  }

  datePickerOpened(evt: any) {
    this._hotkeysService.add(new Hotkey('tab', (): boolean => {
      return false;
    }, undefined, 'Disable tab navigation in date picker'));
  }

  datePickerClosed(evt: any) {
    // this._hotkeysService.remove('tab');
  }

  formApprovalMessage() {
    const roadTaxAutoApprovalStatus = this.roadTaxData['autoApprovalStatus'] || {};
    this.isRoadTaxApproved = true;
    if (roadTaxAutoApprovalStatus['roadTaxVerificationStatus']
          && roadTaxAutoApprovalStatus['roadTaxVerificationStatus'].autoApproved) {
      this.isRoadTaxAutoApproved = true;
      this.roadTaxApprovalMessage = this.APPROVAL_MESSAGE.autoApproved;
    } else {
      this.roadTaxApprovalMessage = this.APPROVAL_MESSAGE.agentApproved;
    }
  }

  addToBulkRejection(event) {
    this.addRoadTaxToRejectList.emit(event);
  }

  updateImageUrl(event) {
    this.fetchData.emit(true);
    if (event.view === 'front') {
      this.imgFront = event.url;
      // Similar to RC - just store the URL, imgFrontData will be set when rotating
    }
    if (event.mode === 'update') {
      this.updateShowApproveButton();
      this._toastMessage.openSnackBarSuccess('Image Saved. Please reload using Shift + R .');
      this.updateImageEnabled = false; // Disable after update is complete
    } else {
      // Only enable update button after rotation, not on initial upload
      this.updateImageEnabled = false;
    }
  }

  rotateImage(imgUrl, degrees, view) {
    if (view === 'front') {
      this.rotateFrontImageDegrees += degrees;
      degrees = this.rotateFrontImageDegrees;
    }

    let response;
    this.spinnerService.show();
    this._roadTaxService.rotateImage(imgUrl, degrees).subscribe(resp => {
      response = resp;
      this.spinnerService.hide();
      if (view === 'front') {
        setTimeout(() => {
          this.imgFrontData = response.data;
          this.updateImageEnabled = true;
          const displayImage = document.getElementById('displayImage') as HTMLImageElement;
          if (displayImage) {
            displayImage.src = response.data;
            this.imageZoomService.initImageZoom('displayImage', {
              width: 400,
              height: 400,
              border: '1px solid black',
              round: false
            });
          }
        }, 300);
      }
    },
    error => {
      const errorMessage = error && error.error && error.error.message || 'Could not rotate road tax';
      this._toastMessage.openSnackBarError(errorMessage);
      this.spinnerService.hide();
    });
  }

  updateRoadTaxImage(view) {
    let response;
    const riderId = this.roadTaxData._id;
    if (view === 'front') {
      // imgFrontData should be the data URL string (set from rotation), imgFront is the existing URL
      if (!this.imgFrontData) {
        this._toastMessage.openSnackBarError('No image data to update. Please rotate the image first or upload a new image.');
        return;
      }
      this._roadTaxService.updateImage(this.imgFrontData, this.imgFront, riderId, 'roadTax', view).subscribe(resp => {
        response = resp;
        this._toastMessage.openSnackBarSuccess('updated image has been saved');
        this._toastMessage.openSnackBarSuccess('Image Saved. Please reload.');
        this.updateShowApproveButton();
        this.fetchData.emit(true);
        this.updateImageEnabled = false;
        this.rotateFrontImageDegrees = 0;
        this.refreshDisplayImage();
      },
      error => {
        const errorMessage = error && error.error && error.error.message || 'Could not update road tax image';
        this._toastMessage.openSnackBarError(errorMessage);
      });
    }
  }

  refreshDisplayImage() {
    // Initialize image zoom with vanilla JavaScript
    setTimeout(() => {
      this.imageZoomService.initImageZoom('displayImage', {
        width: 400,
        height: 400,
        border: '1px solid black',
        round: false
      });
    }, 100);

    // Show BlowupLens using vanilla JavaScript
    const blowupLens = document.getElementById('BlowupLens');
    if (blowupLens) {
      blowupLens.style.display = 'block';
    }
    this.screenBreakpoint = (window.innerWidth <= 1040) ? true : false;
  }

  updateVehicleNumber() {
    if (!this.vehicleNumber || this.vehicleNumber.trim() === '') {
      this._toastMessage.openSnackBarError('Please enter vehicle number');
      return;
    }

    if (this.vehicleNumber === this.oldVehicleNumber) {
      this._toastMessage.openSnackBarError('No update required, Vehicle number is the same');
      return;
    }

    this.spinnerService.show();
    this._roadTaxService.updateVehicleNumber(this.riderId, this.vehicleNumber.replace(/\s/g, '').toUpperCase()).subscribe(
      response => {
        this.spinnerService.hide();
        this.oldVehicleNumber = this.vehicleNumber;
        this._toastMessage.openSnackBarSuccess('Vehicle number updated successfully');
        this.updateShowApproveButton();
        // Emit vehicle number for verification
        this.roadTaxVehicleNumber.emit(this.vehicleNumber);
        this.fetchData.emit();
      },
      error => {
        this.spinnerService.hide();
        const errorMessage = error && error.error && error.error.message || 'Could not update vehicle number';
        this._toastMessage.openSnackBarError(errorMessage);
      }
    );
  }

  hasRoadTaxRequiredFields(): boolean {
    // If image is optional, only require vehicle number
    if (this.isRoadTaxImageOptional) {
      return !!(this.vehicleNumber && this.vehicleNumber.trim() !== '');
    }
    // Otherwise, require all fields: image, number, registrationDate, and vehicleModel
    const hasImage = !!this.imgFront;
    const hasNumber = !!(this.vehicleNumber && this.vehicleNumber.trim() !== '');
    const hasRegistrationDate = !!(this.expiresOnFormControl.value || (this.roadTaxInfo && this.roadTaxInfo.registrationDate));
    const hasVehicleModel = !!this.vehicleModel;
    
    return hasImage && hasNumber && hasRegistrationDate && hasVehicleModel;
  }

  updateShowApproveButton() {
    if (this.roadTaxInfo && this.roadTaxInfo.status == 'processing') {
      this.showApproveButton = this.hasRoadTaxRequiredFields();
    } else {
      this.showApproveButton = false;
    }
  }

  submitAndApproveRoadTax() {
    // Validate based on isImageOptional
    if (!this.isRoadTaxImageOptional) {
      if (!this.imgFront) {
        this._toastMessage.openSnackBarError('Please upload front image');
        return;
      }
    }
    
    if (!this.vehicleNumber || this.vehicleNumber.trim() === '') {
      this._toastMessage.openSnackBarError('Please enter vehicle number');
      return;
    }
    
    if (!this.isRoadTaxImageOptional) {
      if (!this.vehicleModel) {
        this._toastMessage.openSnackBarError('Please select vehicle model');
        return;
      }
      
      if (!this.expiresOnFormControl.value && !(this.roadTaxInfo && this.roadTaxInfo.registrationDate)) {
        this._toastMessage.openSnackBarError('Please enter registration date');
        return;
      }
    }

    this.spinnerService.show();
    let userId = this.riderId;
    if (this.fleetId) {
      userId = this.fleetId;
    }

    // Prepare roadTax data similar to RC
    const roadTaxData = {
      number: this.vehicleNumber,
      vehicleNumber: this.vehicleNumber,
      vehicleModel: this.vehicleModel,
      registrationDate: this.roadTaxInfo && this.roadTaxInfo.registrationDate 
        ? this.roadTaxInfo.registrationDate 
        : (this.expiresOnFormControl.value ? this.expiresOnFormControl.value.toISOString() : null),
      info: {
        vehicleModel: this.vehicleModel,
        registrationDate: this.roadTaxInfo && this.roadTaxInfo.registrationDate 
          ? this.roadTaxInfo.registrationDate 
          : (this.expiresOnFormControl.value ? this.expiresOnFormControl.value.toISOString() : null)
      }
    };

    this._roadTaxService.submitRoadTax(userId, roadTaxData, this.fleetId).subscribe(
      res => {
        const response = res;
        if (response && response['info'] && response['info'].status === 'success') {
          this.roadTaxStatus.emit(true);
          this.showApproveButton = false;
          this.updateImageEnabled = false;
          this.spinnerService.hide();
          this.formApprovalMessage();
          this._toastMessage.openSnackBarSuccess('Road Tax approved successfully');
          this.fetchData.emit();
        } else {
          this.spinnerService.hide();
          this._toastMessage.openSnackBarError('Problem in Road Tax approval');
        }
      },
      error => {
        this.showApproveButton = true;
        this.spinnerService.hide();
        const errorMessage = error && error.error && error.error.message || 'Could not approve Road Tax';
        this._toastMessage.openSnackBarError(errorMessage);
      }
    );
  }

  verifyRoadTaxDoc() {
    this.roadTaxDoc.emit();
    this.asyncRefreshTrigger.next();
  }

  updateVerificationCard(verificationStatus) {
    this.thirdPartyStatus = verificationStatus.status;
    this.thirdPartyMessage = verificationStatus.message;
    this.verificationPlatform = verificationStatus.verifiedBy;
    this.verifiedOn = verificationStatus.verifiedOn;
    this.isRoadTaxAccepted = verificationStatus.status === 'Accepted';
    this.showRoadTaxVerify = !this.isRoadTaxAccepted;
    if (this.isRoadTaxApproved) {
      this.showRoadTaxVerify = false;
    }
  }
}
